import React, { useEffect, useState, useRef } from 'react';

// atoms
import { CustomSpinner, EmptyScreen } from '_atoms';
import { Message } from '_molecules';

// redux
import { useSelector, useDispatch, } from 'react-redux';
import { selectSelectedConversation, selectMessages, clearNotification, selectFetchMessagesStatus } from "_redux/slices/messaging/messaging";

// bootstrap
import Row from 'react-bootstrap/Row';

// styling
import { Spacing } from '_styles';


function convertTimestamp(timestampString) {
    const months = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
    ];

    const date = new Date(timestampString);

    const year = String(date.getFullYear());
    const month = months[date.getMonth()];
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const amOrPm = hours >= 12 ? 'pm' : 'am';

    // Convert hours to 12-hour format
    const formattedHours = hours % 12 || 12;

    const formattedTimestamp = `${day} ${month} ${year}, ${formattedHours}:${minutes}${amOrPm}`;

    return formattedTimestamp;
}

const PassengerChat = (props) => {

    // redux
    const dispatch = useDispatch();
    const selectedConversation = useSelector(selectSelectedConversation);
    const messages = useSelector(selectMessages);
    //const messagesGroupedByDate = useSelector(selectMessageGroupedByDate);

    const fetchMessageStatus = useSelector(selectFetchMessagesStatus);

    const [firstFetch, setFirstFetch] = useState(true);         // used to stop screen from loading everytime we get new live messages

    // Scroll to the bottom when the component mounts or when new messages are added
    useEffect(() => {
        setTimeout(() => {
            if (scrollContainerRef.current && scrollContainerRef.current.scrollHeight != null) {
                scrollContainerRef.current.scrollTop = scrollContainerRef.current.scrollHeight;
            }
        }, 100);
    }, [messages]);

    useEffect(() => {
        if (selectedConversation && selectedConversation.notification) {
            // message has been viewed, set notification to false now
            dispatch(clearNotification(selectedConversation.id))
        }

    }, [selectedConversation]);

    useEffect(() => {
        if (fetchMessageStatus == 'succeeded') {
            setFirstFetch(false);   // after getting messages intially we dont want to show loading anymore
        }
    }, [fetchMessageStatus]);

    const scrollContainerRef = useRef(null);

    return (
        <div style={{ 'overflow-y': 'scroll', height: '80%', marginTop: Spacing.SCALE_4 }} ref={scrollContainerRef}>

            {

                /* Loading */
                fetchMessageStatus && firstFetch == 'loading' ? <CustomSpinner rowCenter={true} /> :

                    /* No Messages */
                    messages != undefined && Object.keys(messages).length == 0 ? <EmptyScreen>No Messages</EmptyScreen> :

                        /* List of Messages */
                        messages != undefined || messages != {} || messages != null ?
                            <div>
                                {Object.keys(messages).map((date) =>
                                    <div>
                                        <Row style={{ textAlign: 'center', display: 'flex', justifyContent: 'center', padding: Spacing.SCALE_8 }}>
                                            <p style={{ fontWeight: '500', opacity: 0.6 }}>{convertTimestamp(date)}</p>
                                        </Row>
                                        {messages[date].map((message) =>
                                            <Message message={message} time={date}>{message.text}</Message>
                                        )}
                                    </div>
                                )}
                            </div>
                            : ""}

        </div>
    );
};

export default PassengerChat;